import * as React from "react";
function SvgDashboard(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect
        x={1}
        y={1}
        width={18}
        height={6}
        rx={1}
        ry={1}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <rect
        x={13}
        y={25}
        width={18}
        height={6}
        rx={1}
        ry={1}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <rect
        x={25}
        y={1}
        width={6}
        height={6}
        rx={1}
        ry={1}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <rect
        x={25}
        y={13}
        width={6}
        height={6}
        rx={1}
        ry={1}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <rect
        x={13}
        y={13}
        width={6}
        height={6}
        rx={1}
        ry={1}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <rect
        x={1}
        y={13}
        width={6}
        height={6}
        rx={1}
        ry={1}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <rect
        x={1}
        y={25}
        width={6}
        height={6}
        rx={1}
        ry={1}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDashboard);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
